import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const stripeKey = document.querySelector('meta[name="stripe-key"]')?.content
    if (!stripeKey) return

    window.stripe = Stripe(stripeKey);

    if (this.element.dataset.sessionId) {
      window.stripe.redirectToCheckout({
        sessionId: this.element.dataset.sessionId,
      }).catch(() => {
        alert("Unable to redirect to checkout. Please try again.");
      });
    } else {
      this.clickHandler = (e) => this.handleBuyClick(e);
      document.addEventListener("click", this.clickHandler);
    }
  }

  get stripeReady() {
    return typeof window.stripe !== "undefined" && window.stripe !== null;
  }

  disconnect() {
    if (this.clickHandler) {
      document.removeEventListener("click", this.clickHandler);
    }
  }

  handleBuyClick(e) {
    const button = e.target.closest(".btn-buy, .btn-new-checkout");
    if (!button) return;

    if (!this.stripeReady) {
      alert("Payment system is not available. Please refresh the page and try again.");
      return;
    }

    if (button.dataset.loading === "true") return;

    button.dataset.loading = "true";
    const originalText = button.innerHTML;
    button.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

    const data = { plan_name: button.dataset.name };
    if (button.classList.contains("btn-new-checkout")) {
      data.trade_show = true;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch("/get_stripe_session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Server responded with ${response.status}`);
        return response.json();
      })
      .then((responseData) => {
        if (!responseData.sessionId) throw new Error("No session ID returned");
        window.stripe.redirectToCheckout({
          sessionId: responseData.sessionId,
        }).catch(() => {
          button.dataset.loading = "false";
          button.innerHTML = button.dataset.originalText || originalText || "Get Started";
          alert("Unable to redirect to checkout. Please try again.");
        });
      })
      .catch(() => {
        button.dataset.loading = "false";
        button.innerHTML = button.dataset.originalText || originalText || "Get Started";
        alert("Unable to start checkout. Please try again.");
      });
  }
}
